import React from "react";
import { BaseIcon, BaseIconProps } from "./baseIcon";

export const SpotIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM9 7C7.89543 7 7 7.89543 7 9V11C7 12.1046 7.89543 13 9 13H11C12.1046 13 13 12.1046 13 11V9C13 7.89543 12.1046 7 11 7H9Z"
        className="oui-fill-base-contrast-80"
      />
      <path
        d="M18.8034 8.1276C18.7434 7.84577 19.0603 7.62722 19.2756 7.81876C20.9466 9.3053 22.0006 11.4702 22.0006 13.8826C22.0003 18.3657 18.3655 22.0005 13.8824 22.0007C11.4701 22.0007 9.30514 20.9467 7.81859 19.2758C7.62706 19.0605 7.84563 18.7434 8.1275 18.8033C8.73168 18.9317 9.35821 18.9998 10.0006 18.9998C10.1368 18.9997 10.2723 18.9957 10.407 18.9893C10.4716 18.9862 10.5354 19.0036 10.5898 19.0385C11.5405 19.6468 12.6701 20.0007 13.8824 20.0007C17.1555 20.0005 19.8288 17.4294 19.9927 14.197L20.0006 13.8826C20.0006 12.6708 19.6471 11.5414 19.0392 10.591C19.0044 10.5365 18.987 10.4727 18.9901 10.4082C18.9965 10.2728 19.0006 10.1365 19.0006 9.99976C19.0005 9.35761 18.9321 8.73148 18.8034 8.1276Z"
        className="oui-fill-base-contrast-80"
      />
    </BaseIcon>
  );
};
